export const LS_KEY = 'twinkle-chess-last-level';
export const TIME_ATTACK_DURATION = 30;
export const TIME_BONUS_CORRECT_MOVE = 3;
export const TIME_PENALTY_WRONG_MOVE = 5;
